import { environment } from './../../../environments/environment';
import { Component, HostListener, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ReportService } from 'src/app/services/report.service';
import { TokenExpireService } from 'src/app/services/token-expire.service';
import { CustomLoaderService } from '../../services/custom-loader.service';
import { EncrdecrService } from 'src/app/Auth/encrdecr.service';
import { FormBuilder, FormGroup } from '@angular/forms';
declare var $: any;
@Component({
  selector: 'app-newnfo',
  templateUrl: './newnfo.component.html',
  styleUrls: ['./newnfo.component.scss']
})
export class NewnfoComponent implements OnInit {
  IsSubscribed = environment.IsSubscribed;
  FilterForm: FormGroup;
  CompanyName = environment.CompayName;
  ArrayofResposnse: any = [];
  ArrTempFundData: any = [];
  ArrnfoData: any = [];
  showNFODiv: boolean = false;
  SearchFund: string = '';
  IsMobile: boolean = false;
  switchStatus: boolean = true;
  redeemStatus: boolean = true;
  SWPStatus: boolean = true; //added by adarsh 27102023
  STPStatus: boolean = true; //added by adarsh 27102023
  constructor(
    private fb: FormBuilder,
    private exploreServices: ReportService,
    private Loader: CustomLoaderService,
    private Logout: TokenExpireService,
    private router: Router,
    private route: ActivatedRoute,
    private EncrdecrService: EncrdecrService
  ) {
    this.FilterForm = fb.group({
      // CheckFilter2 :["false"],
      // CheckFilter1 :["false"],
      CheckFilter: ['1']
      // CheckFilter3 :["true"],
    });
  }
  ngAfterViewInit() {
    // $('#MainNAV .nav-item .nav-link').removeClass('active');
    // $('#Id_ValueAdds .nav-link').addClass('active');
  }
  GetClientRedeemStatus(ClientId) {
    this.exploreServices
      .getClientTransactionStatus(ClientId, 'Redeem')
      .subscribe(
        (data) => {
          if (data.ArrayOfResponse[0].TEXTFIELD == 'False') {
            this.Loader.hide();
            this.redeemStatus = false;
          } else {
            this.Loader.hide();
            this.redeemStatus = true;
          }
        },
        (err) => {
          this.Loader.hide();
        }
      );
  }
  GetClientSWPStatus(ClientId) {
    this.exploreServices.getClientTransactionStatus(ClientId, 'SWP').subscribe(
      (data) => {
        if (data.ArrayOfResponse[0].TEXTFIELD == 'False') {
          this.SWPStatus = false;
        } else {
          this.Loader.hide();
          this.SWPStatus = true;
        }
      },
      (err) => {
        this.Loader.hide();
      }
    );
  }
  GetClientSTPStatus(ClientId) {
    this.exploreServices.getClientTransactionStatus(ClientId, 'STP').subscribe(
      (data) => {
        if (data.ArrayOfResponse[0].TEXTFIELD == 'False') {
          this.Loader.hide();
          this.STPStatus = false;
        } else {
          this.Loader.hide();
          this.STPStatus = true;
        }
      },
      (err) => {
        this.Loader.hide();
      }
    );
  }
  GetClientSwitchStatus(ClientId) {
    debugger;
    this.exploreServices
      .getClientTransactionStatus(ClientId, 'Switch')
      .subscribe((data) => {
        if (data.ArrayOfResponse[0].TEXTFIELD == 'False') {
          this.switchStatus = false;
        } else {
          this.switchStatus = true;
        }
      });
  }
  SetViewPort(w) {
    if (w <= 767) {
      this.IsMobile = true;
    } else {
      this.IsMobile = false;
    }
  }
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.SetViewPort(event.target.innerWidth);
  }
  ngOnInit() {
    this.SetViewPort(window.innerWidth);
    if (
      parseInt(
        this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0'))
      ) == 3
    ) {
      this.SWPStatus =
        this.EncrdecrService.getDecr(sessionStorage.getItem('@SWPFLAG')) == '1'
          ? true
          : false; //SWPFlag
      this.STPStatus =
        this.EncrdecrService.getDecr(sessionStorage.getItem('@STPFLAG')) == '1'
          ? true
          : false; //STPFlag
      this.switchStatus =
        this.EncrdecrService.getDecr(sessionStorage.getItem('@SwitchFlag')) ==
        '1'
          ? true
          : false; //SwitchFlag
      this.redeemStatus =
        this.EncrdecrService.getDecr(sessionStorage.getItem('@RedeemFlag')) ==
        '1'
          ? true
          : false; //RedeemFlag
    }
    $(document).ready(function () {
      $('img.svg').each(function () {
        var $img = $(this);
        var imgID = $img.attr('id');
        var imgClass = $img.attr('class');
        var imgURL = $img.attr('src');

        $.get(
          imgURL,
          function (data) {
            // Get the SVG tag, ignore the rest
            var $svg = $(data).find('svg');

            // Add replaced image's ID to the new SVG
            if (typeof imgID !== 'undefined') {
              $svg = $svg.attr('id', imgID);
            }
            // Add replaced image's classes to the new SVG
            if (typeof imgClass !== 'undefined') {
              $svg = $svg.attr('class', imgClass + ' replaced-svg');
            }

            // Remove any invalid XML tags as per http://validator.w3.org
            $svg = $svg.removeAttr('xmlns:a');

            // Replace image with new SVG
            $img.replaceWith($svg);
          },
          'xml'
        );
      });
    });
    this.ArrayofResposnse = [
      {
        AmcCode: '400001',
        SchemeName: 'GareeboFund',
        AssetType: 'Equity',
        InceptionDate: '08/08/2023',
        RiskLable: 'Too Much High Violent',
        CategoryName: 'ULTRA PRO MAX'
      },
      {
        AmcCode: '400060',
        SchemeName: 'Maseeha fund',
        AssetType: 'Debt',
        InceptionDate: '08/08/2023',
        RiskLable: 'tanne soch nhi hogi',
        CategoryName: 'ULTRA PRO MAX'
      },
      {
        BSESchemeCode: 'AXSVGP-GR',
        SchemeCode: 46368,
        NAV: 12.761,
        NAVDate: '2023-08-07T00:00:00',
        ISIN: 'INF846K018J8',
        AmcCode: 400040,
        BSEAMCCode: 'AXISMUTUALFUND_MF',
        AMCName: 'Axis Asset Management Company Ltd.',
        SchemeName: 'AXIS SILVER FUND OF FUND REGULAR GROWTH',
        SchemeTypeCode: 1,
        SchemeType: 'Open ended scheme',
        SchemeOptionCode: 1,
        SchemeOption: 'Growth',
        CategoryCode: 85,
        CategoryName: 'FoFs (Domestic) - Silver',
        AssetType: 'Commodity',
        AssetCode: 4,
        RiskLable: 'Moderately High',
        PurchaseAllowed: 'Y',
        PurchaseTransactionMode: 'DP',
        MinimumPurchaseAmount: 5000,
        AdditionalPurchaseAmount: 1000,
        MaximumPurchaseAmount: 0,
        DividendReinvestmentFlag: 'Z',
        SIPFLAG: 'Y',
        InceptionDate: 'Sep 21, 2022',
        InceptionReturn: 65.13,
        NFOStart: '2022-09-02T00:00:00',
        NFOEnd: '2022-09-16T00:00:00',
        minsipamount: '1000',
        RecFlag: 'False',
        ReturnList: [
          {
            SchemeCode: 46368,
            ReturnValue: 0,
            ReturnType: 'One Years',
            ReturnDate: 'Jan 01, 1900'
          },
          {
            SchemeCode: 46368,
            ReturnValue: 0,
            ReturnType: 'Three Years',
            ReturnDate: 'Jan 01, 1900'
          },
          {
            SchemeCode: 46368,
            ReturnValue: 0,
            ReturnType: 'Five Years',
            ReturnDate: 'Jan 01, 1900'
          },
          {
            SchemeCode: 46368,
            ReturnValue: 65.1253,
            ReturnType: 'Since Inception',
            ReturnDate: 'Sep 21, 2022'
          }
        ]
      },
      {
        BSESchemeCode: 'AXSVDP-DP',
        SchemeCode: 46883,
        NAV: 12.761,
        NAVDate: '2023-08-07T00:00:00',
        ISIN: 'INF846K019J6',
        AmcCode: 400040,
        BSEAMCCode: 'AXISMUTUALFUND_MF',
        AMCName: 'Axis Asset Management Company Ltd.',
        SchemeName: 'AXIS SILVER FUND OF FUND REGULAR IDCW PAYOUT',
        SchemeTypeCode: 1,
        SchemeType: 'Open ended scheme',
        SchemeOptionCode: 2,
        SchemeOption: 'Dividend',
        CategoryCode: 85,
        CategoryName: 'FoFs (Domestic) - Silver',
        AssetType: 'Commodity',
        AssetCode: 4,
        RiskLable: 'Very High',
        PurchaseAllowed: 'Y',
        PurchaseTransactionMode: 'DP',
        MinimumPurchaseAmount: 5000,
        AdditionalPurchaseAmount: 1000,
        MaximumPurchaseAmount: 0,
        DividendReinvestmentFlag: 'N',
        SIPFLAG: 'Y',
        InceptionDate: 'Sep 21, 2022',
        InceptionReturn: 65.13,
        NFOStart: '2022-09-02T00:00:00',
        NFOEnd: '2022-09-16T00:00:00',
        minsipamount: '1000',
        RecFlag: 'False',
        ReturnList: [
          {
            SchemeCode: 46883,
            ReturnValue: 0,
            ReturnType: 'One Years',
            ReturnDate: 'Jan 01, 1900'
          },
          {
            SchemeCode: 46883,
            ReturnValue: 0,
            ReturnType: 'Three Years',
            ReturnDate: 'Jan 01, 1900'
          },
          {
            SchemeCode: 46883,
            ReturnValue: 0,
            ReturnType: 'Five Years',
            ReturnDate: 'Jan 01, 1900'
          },
          {
            SchemeCode: 46883,
            ReturnValue: 65.1253,
            ReturnType: 'Since Inception',
            ReturnDate: 'Sep 21, 2022'
          }
        ]
      },
      {
        BSESchemeCode: 'AXSCGP-GR',
        SchemeCode: 21651,
        NAV: 74.31,
        NAVDate: '2023-08-07T00:00:00',
        ISIN: 'INF846K01K01',
        AmcCode: 400040,
        BSEAMCCode: 'AXISMUTUALFUND_MF',
        AMCName: 'Axis Asset Management Company Ltd.',
        SchemeName: 'AXIS SMALL CAP FUND - REGULAR PLAN GROWTH',
        SchemeTypeCode: 1,
        SchemeType: 'Open ended scheme',
        SchemeOptionCode: 1,
        SchemeOption: 'Growth',
        CategoryCode: 33,
        CategoryName: 'Equity - Small cap Fund',
        AssetType: 'Equity',
        AssetCode: 1,
        RiskLable: 'Very High',
        PurchaseAllowed: 'Y',
        PurchaseTransactionMode: 'DP',
        MinimumPurchaseAmount: 500,
        AdditionalPurchaseAmount: 100,
        MaximumPurchaseAmount: 10000000,
        DividendReinvestmentFlag: 'Z',
        SIPFLAG: 'Y',
        InceptionDate: 'Nov 29, 2013',
        InceptionReturn: 23.04,
        NFOStart: '2013-11-11T00:00:00',
        NFOEnd: '2013-11-25T00:00:00',
        minsipamount: '100',
        RecFlag: 'False',
        ReturnList: [
          {
            SchemeCode: 21651,
            ReturnValue: 6.7491,
            ReturnType: 'One Years',
            ReturnDate: 'Nov 03, 2021'
          },
          {
            SchemeCode: 21651,
            ReturnValue: 26.4685,
            ReturnType: 'Three Years',
            ReturnDate: 'Nov 07, 2019'
          },
          {
            SchemeCode: 21651,
            ReturnValue: 18.521,
            ReturnType: 'Five Years',
            ReturnDate: 'Nov 07, 2017'
          },
          {
            SchemeCode: 21651,
            ReturnValue: 23.0406,
            ReturnType: 'Since Inception',
            ReturnDate: 'Nov 29, 2013'
          }
        ]
      }
    ];
    this.BindExploreFundsData();

    // setTimeout(() => {
    //   this.Loader.hide();
    // }, 1000);
  }

  BindExploreFundsData() {
    this.Loader.show();
    let typeoption = 'NEWNFO';
    this.exploreServices.GetExploreFundsData(typeoption).subscribe(
      (res: any) => {
        //alert('data come');
        // console.log('List '+ res.ArrayOfResponse);
        if (res != null) {
          if (
            res.Message != null &&
            res.Message != '' &&
            res.Message.indexOf('Not Authorized') > -1
          ) {
            this.Loader.hide();
            //this.Logout.LogoutUser();
            return;
          } else {
            this.ArrTempFundData = res.ArrayOfResponse;
            this.ArrnfoData = this.ArrTempFundData;
            this.ArrnfoData.sort((a,b)=>new Date(a.NFOEnd).getTime() - new Date(b.NFOEnd).getTime())
            this.showNFODiv = true;
            this.ArrTempFundData.map((arr, index) => {
              arr.IsShowLoadMore = false;
            });
            this.showFilterByAsset('G');
            this.Loader.hide();

            console.log(this.ArrTempFundData);
          }
        }
      },
      (err) => {
        //console.log(err);
        this.Loader.hide;
      }
    );
  }

  //added by adarsh 28/11/2023
  showFilterByAsset(searchBy: any) {
    debugger;
    let SearchText: string = '';
    let TempArrayArnfodata = this.ArrTempFundData;
    let Filtered = [];
    switch (searchBy) {
      case 'G':
        SearchText = 'growth';
        break;
      case 'DP':
        SearchText = '- idcw payout';
        break;
      case 'DR':
        SearchText = '- idcw reinvestment';
        break;
      case 'ALL':
        SearchText = '';
        Filtered = TempArrayArnfodata;
        break;
    }

    TempArrayArnfodata.map((arr, index) => {
      if (
        arr.SchemeName.toLowerCase().indexOf(SearchText) >= 0 ||
        arr.SchemeName.includes(SearchText)
      ) {
        Filtered.push(arr);
      }
    });
    this.ArrnfoData = Filtered;
  }

  redirectToTransactPage(BSESchemeCode, BSEAMCCode, para) {
    //alert('Explore Funds Scheme Code ='+ BSESchemeCode + '\nAMCCode = '+ BSEAMCCode);
    //////
    sessionStorage.setItem(
      'Shv3IZ7dNAGND6w',
      this.EncrdecrService.setEncr(BSESchemeCode)
    ); //ExpFund_BSESchemeCode
    sessionStorage.setItem(
      'c1er1RAHrEZBEUH',
      this.EncrdecrService.setEncr(BSEAMCCode)
    ); //ExpFund_BSEAMCCode
    sessionStorage.setItem(
      'jsdjfysbfsdbfsdfsdf',
      this.EncrdecrService.setEncr('Explore-Fund')
    );
    switch (para) {
      case 0:
        this.router.navigate(['/transaction/lumpsum'], {
          relativeTo: this.route
        });
        break;
      case 1:
        this.router.navigate(['/transaction/sip'], { relativeTo: this.route });
        break;
    }
  }

  MakeSearchFundArr(SearchFund) {
    // debugger;
    let TempFinalArr: any;
    let InnerSearchArr = [];
    if (SearchFund === '') {
      TempFinalArr = this.ArrTempFundData;
      this.ArrnfoData = TempFinalArr;
    } else {
      this.ArrTempFundData.forEach((SingleArr) => {
        if (
          SingleArr.SchemeName.trim()
            .toLowerCase()
            .includes(SearchFund.toLowerCase())
        ) {
          InnerSearchArr.push(SingleArr);
        }
      });
      //TempFinalArr = this.MakeFavoriteArr(InnerSearchArr, SortingBy, IsFavorite, SchemeOption, SchemeType, IsNFO);
      TempFinalArr = InnerSearchArr;
      this.ArrnfoData = TempFinalArr;
    }
    return TempFinalArr;
  }
}
